export default "__VITE_PUBLIC_ASSET__628ffeda__"